const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M20 7c0-.15-.03-.28-.09-.41-.01-.03-.04-.06-.06-.09-.05-.09-.11-.17-.18-.24-.01-.01-.01-.02-.02-.03-.03-.02-.07-.03-.1-.05a.836.836 0 00-.23-.12.508.508 0 00-.17-.03C19.1 6.02 19.05 6 19 6c-.03 0-.06.01-.09.02-.03 0-.05-.01-.08 0l-4.83.8V3.41l1.29 1.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71l-3-3c-.04-.04-.1-.07-.16-.1-.05-.04-.1-.08-.17-.11A.995.995 0 0013 0c-.13 0-.26.03-.39.08-.06.02-.1.07-.15.1-.06.04-.12.07-.17.12l-3 3c-.18.17-.29.42-.29.7a1.003 1.003 0 001.71.71L12 3.41V8c0 .55.45 1 1 1 .06 0 .11-.02.16-.03v.02L18 8.18v8.24c-.59-.26-1.27-.42-2-.42-2.21 0-4 1.34-4 3s1.79 3 4 3 4-1.34 4-3V7zm-4 13c-1.24 0-2-.65-2-1s.76-1 2-1 2 .65 2 1-.76 1-2 1zM13.16 8.99z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.84 7.68l-2 .33c-.05.01-.09.04-.13.05-.05.02-.1.03-.15.05-.06.03-.12.08-.18.12-.04.03-.08.06-.11.09-.05.06-.09.13-.13.2-.02.04-.05.07-.07.11-.04.12-.07.24-.07.37v9.42c-.59-.26-1.27-.42-2-.42-2.21 0-4 1.34-4 3s1.79 3 4 3 4-1.34 4-3V9.85l1.16-.19c.54-.09.91-.61.82-1.15a.989.989 0 00-1.14-.83zM4 22c-1.24 0-2-.65-2-1s.76-1 2-1 2 .65 2 1-.76 1-2 1z"
});

const SvgAttachAudio = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttachAudio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attach-audio.00014d7f.svg";
export { ForwardRef as ReactComponent };